var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"navBox"},[_c('router-link',{attrs:{"to":"./index"}},[_c('van-button',[_vm._v("用户列表")])],1),_c('router-link',{attrs:{"to":"./crossChains"}},[_c('van-button',[_vm._v("跨链申请")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }